import { values } from 'lodash'

export default class TCardColorMark {
  static allVariants = {
    none: {
      code: 'none',
      color: 'rgba(0,0,0,0)',
      name: 'Нет цвета',
    },
    dark_blue: {
      code: 'dark_blue',
      color: '#0c5efd',
      name: 'Суши (синий)',
    },
    blue: {
      code: 'blue',
      color: '#1f98ff',
      name: 'Холодные роллы (голубой)',
    },
    pink: {
      code: 'pink',
      color: '#f90978',
      name: 'Запеченные + пицца (розовый)',
    },
    yellow: {
      code: 'yellow',
      color: '#fcc600',
      name: 'Фритюр (желтый)',
    },
    green: {
      code: 'green',
      color: '#2bb819',
      name: 'Салат (зеленый)',
    },
    orange: {
      code: 'orange',
      color: '#fa7004',
      name: 'Супы и воки (оранжевый)',
    },
    gray: {
      code: 'gray',
      color: '#d6d6d6',
      name: 'Соусы (серый)',
    },
  }

  constructor (value) {
    this.value = TCardColorMark.allVariants[value] || TCardColorMark.allVariants.none
  }

  static getAllVariants () {
    return values(TCardColorMark.allVariants)
  }

  static noneValue () {
    return TCardColorMark.allVariants.none.code
  }
}
